import { render } from "./HelloI18n.vue?vue&type=template&id=769f8ce8"
import script from "./HelloI18n.vue?vue&type=script&lang=js"
export * from "./HelloI18n.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./HelloI18n.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "C:\\Users\\omer\\Desktop\\Projeler\\tsoftapps-dev-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__